//used by Cards.js and Single.js
import { useMemo } from "react"
import { useNavigate } from "react-router-dom"
export default function Card({path,comment,createdAt,user,id}){
  const navigate = useNavigate()
  const handleOnClick = () => {
    navigate(`/comments/${id}`, { state: { id } })
  }
  const timestamp = useMemo(() => {
    const date = `${new Date(createdAt?.seconds * 1000)}`.split(" ")
    return `${date[1]} ${date[2]} ${date[3]}`
  }, [createdAt?.seconds])
  return (
    <div className="mb-5" onClick={handleOnClick}>
      <div className="card" style={{ width: "18rem" }}>
        <div style={{
          height: "220px",
          backgroundImage: `url(${path})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat"
        }}>
        </div>
        <h5 className="text-center mt-1">{comment}</h5>
        <div className="d-flex justify-content-between p-2">
          <p>{timestamp}</p>
          <i>{`by: ${user}`}</i>
        </div>
      </div>
    </div>
  )
}